import { jsxs as l, Fragment as c, jsx as o } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import p from "../server/server-component.mjs";
import h from "./live-editing.mjs";
const s = a(
  ({ story: e, bridgeOptions: r, ...t }, n) => {
    if (!e)
      return console.error(
        "Please provide a 'story' property to the StoryblokServerComponent"
      ), null;
    if (globalThis != null && globalThis.storyCache.has(e.uuid) && (e = globalThis.storyCache.get(e.uuid), globalThis.storyCache.delete(e.uuid)), typeof e.content == "string")
      try {
        e.content = JSON.parse(e.content);
      } catch (i) {
        console.error(
          "An error occurred while trying to parse the story content",
          i
        ), e.content = {};
      }
    return /* @__PURE__ */ l(c, { children: [
      /* @__PURE__ */ o(p, { ref: n, blok: e.content, ...t }),
      /* @__PURE__ */ o(h, { story: e, bridgeOptions: r })
    ] });
  }
);
export {
  s as default
};
